import React from "react";

import { UserProfileForm } from "../../../components/admin/u1/profile/UserProfileForm";
import "../../../components/common/u1/tokens.css";

/* u1 User Profile — /dashboard/profile. */
export default function Profile() {
  return (
    <div data-testid="u1-profile-page" className="u1-root py-5">
      <UserProfileForm />
    </div>
  );
}
